var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { ConditionPart, } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { ListExpressionRenderer } from './list_expression_renderer';
import { browserUtils } from '../../../utils/browser_utils';
import { QPEditablePart } from '../../../types/qp_editable_part';
var AttributeExpressionRenderer = /** @class */ (function (_super) {
    __extends(AttributeExpressionRenderer, _super);
    function AttributeExpressionRenderer(panel, expression, entitiesMenu, slot) {
        var _this = _super.call(this, panel, expression, null, slot) || this;
        _this.menu = entitiesMenu;
        return _this;
    }
    AttributeExpressionRenderer.prototype.renderEditor = function () {
        //create menu
    };
    AttributeExpressionRenderer.prototype.getLabelText = function () {
        var model = this.panel.getContext().getModel();
        var attrId = this.expression.value;
        var attrObj = attrId ? model.getAttributeByIdSafe(attrId) : null;
        var attrFormat = this.panel.options.attrElementFormat;
        return attrObj ? model.getAttributeText(attrObj, attrFormat) : this.getEmptyText();
    };
    AttributeExpressionRenderer.prototype.setValue = function (value, silent) {
        if (silent === void 0) { silent = false; }
        silent = silent && value !== this.expression.value;
        var result = _super.prototype.setValue.call(this, value, true);
        if (!silent) {
            this.expression.getParent().fireChangedEvent(ConditionPart.EntityAttr | ConditionPart.Operator);
        }
        return result;
    };
    AttributeExpressionRenderer.prototype.isEditable = function () {
        return !this.isReadOnly()
            && ((this.panel.options.editableParts & QPEditablePart.Attribute) === QPEditablePart.Attribute);
    };
    AttributeExpressionRenderer.prototype.getEmptyText = function () {
        return this.panel.options.emptyTextAttribute || i18n.getText('MsgEmptyAttrValue');
    };
    AttributeExpressionRenderer.prototype.getClassesToAdd = function () {
        return this.cssPrefix + "-condelement " + this.cssPrefix + "-attrelement";
    };
    AttributeExpressionRenderer.prototype.adjustWidth = function () {
        if (browserUtils.isMobileMode()) {
            return;
        }
        var elWidth = this.element.clientWidth;
        var parWidth = this.element.parentElement.clientWidth;
        if (elWidth > parWidth / 2) {
            domel(this.element)
                .addClass(this.cssPrefix + "-attrelement-wide");
        }
    };
    return AttributeExpressionRenderer;
}(ListExpressionRenderer));
export { AttributeExpressionRenderer };
//# sourceMappingURL=attribute_expression_renderer.js.map